export const VIEW_TEAMS_LOADING_STATE = 'VIEW_TEAMS_LOADING_STATE';
